// The "yellow = suggested, still unverified" marks and the prefill hints for
// a slip live in their own localStorage keys, separate from the draft
// envelope. These helpers let the cross-device draft mirror carry them along,
// so a suggestion the pilot hasn't verified stays yellow on every device
// (and the expense editor's date hints work wherever the slip was filled in).

export function readSlipAux(tripId) {
  try {
    return {
      segMarks: JSON.parse(localStorage.getItem(`slipSegMarks_${tripId}`) || "[]"),
      segHints: JSON.parse(localStorage.getItem(`slipSegHints_${tripId}`) || "{}"),
      pilotMarks: JSON.parse(localStorage.getItem(`slipPilotMarks_${tripId}`) || "[]"),
      pilotHints: JSON.parse(localStorage.getItem(`slipPilotHints_${tripId}`) || "{}"),
      pilotCount: Number(localStorage.getItem(`slipPilotCount_${tripId}`) || "0"),
    };
  } catch {
    return null;
  }
}

// Only called when adopting a NEWER cloud draft; a cloud envelope without aux
// (pushed before this existed) leaves the local marks alone — stale yellow is
// safer than suggestions silently looking verified.
export function writeSlipAux(tripId, aux) {
  if (!aux) return;
  try {
    localStorage.setItem(`slipSegMarks_${tripId}`, JSON.stringify(aux.segMarks || []));
    localStorage.setItem(`slipSegHints_${tripId}`, JSON.stringify(aux.segHints || {}));
    localStorage.setItem(`slipPilotMarks_${tripId}`, JSON.stringify(aux.pilotMarks || []));
    localStorage.setItem(`slipPilotHints_${tripId}`, JSON.stringify(aux.pilotHints || {}));
    localStorage.setItem(`slipPilotCount_${tripId}`, String(aux.pilotCount || 0));
  } catch { /* quota */ }
}
